import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {IRailSliderConfig} from '@dazn/lp-web/src/types/rail.types';

export const railSliderConfig: Record<number, IRailSliderConfig> = {
    425: {
        slidesPerView: 1,
        slidesPerGroup: 1
    },
    768: {
        slidesPerView: 3,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4,
        slidesPerGroup: 4
    },
    1440: {
        slidesPerView: 4,
        slidesPerGroup: 4
    },
    1920: {
        slidesPerView: 6,
        slidesPerGroup: 6
    }
};

export const railTypeConfig = {
    [ComponentTypes.STANDARD_RAIL]: {
        width: 300,
        aspectRatio: 16 / 9
    },
    [ComponentTypes.COMING_UP_RAIL]: {
        width: 300,
        aspectRatio: 2 / 3
    },
    [ComponentTypes.SUBSCRIPTIONS_RAIL]: {
        width: 300,
        aspectRatio: 2 / 3
    },
    [ComponentTypes.SHOWS_RAIL]: {
        width: 300,
        aspectRatio: 2 / 3
    },
    [ComponentTypes.SPOTLIGHT_RAIL]: {
        width: 300,
        aspectRatio: 16 / 9
    }
};

export const getRailSlidesPerView = (viewportWidth: number): number => {
    const sortedBreakpoints = Object.keys(railSliderConfig)
        .map(Number)
        .sort((a, b) => a - b);

    let slidesPerView = 1;

    for (const breakpoint of sortedBreakpoints) {
        if (viewportWidth >= breakpoint) {
            slidesPerView = railSliderConfig[breakpoint].slidesPerView;
        }
    }

    return viewportWidth <= 1024 ? slidesPerView + 1 : slidesPerView;
};
